import { makeStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  printButton: {
    marginBottom: '3.58vh',
    marginRight: 12,
    fontSize: vh(2.08),
    '&:hover': {
      boxShadow: 'none',
    },
  },
  closeButton: {
    marginLeft: '1.75vw',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
  },
  dialogContent: {
    backgroundColor: themeColor.lightBackground,
  },
}));
